(() => {
  const BUTTON_SELECTOR = 'button.tpo_add-to-cart';
  const EASIFY_ROOT_SELECTORS = ['.tpo_option-set-wrapper', '.tpo_option-set-container'];

  const FAILSAFE_MS = 3500;
  const POLL_EVERY_MS = 25;
  const POLL_MAX_MS = 1500;

  function setDisabled(btn, disabled) {
    btn.disabled = !!disabled;
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    btn.style.pointerEvents = disabled ? 'none' : '';
    btn.style.opacity = disabled ? '0.6' : '';
  }

  function easifyRootEl() {
    for (const sel of EASIFY_ROOT_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function guardButton(btn) {
    // Don't repeatedly re-guard the same button
    if (btn.dataset.easifyGuarded === '1') return;
    btn.dataset.easifyGuarded = '1';

    setDisabled(btn, true);

    const enableIfReady = () => {
      if (easifyRootEl()) {
        setDisabled(btn, false);
        return true;
      }
      return false;
    };

    if (enableIfReady()) return;

    const start = Date.now();
    const poll = setInterval(() => {
      if (enableIfReady() || Date.now() - start > POLL_MAX_MS) {
        clearInterval(poll);
      }
    }, POLL_EVERY_MS);

    const obs = new MutationObserver(() => {
      if (enableIfReady()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(() => {
      if (btn.disabled) setDisabled(btn, false);
      clearInterval(poll);
      obs.disconnect();
    }, FAILSAFE_MS);
  }

  function run() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(guardButton);
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();